<template>
  <!-- width="full"
  size="md"-->

  <div>
    <div v-if="isBasicEligibility">
      <EndPage :background="mainColor">
        <Feedback
          :title="`Dear ${getName},`"
          :subtitle="
            `Thank you for your application. Based on the information provided by you,
          it looks like the Deem ${isProducttype} is not the best fit for you.`
          "
          bigger-subtitle
        />
        <template slot="actions">
          <Button
            v-for="(action, index) in actions"
            :key="`endpage-action-${index}`"
            :pseudolink="isPseudoLink(index)"
            :color="getColor(index)"
            v-html="getHTML(index, action.label)"
            :click="redirectToDeem"
            >BACK TO HOME</Button
          >
        </template>
      </EndPage>
    </div>

    <div v-if="isCreditScoreeAppian">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
        <template slot="actions">
          <Button
            v-for="(action, index) in actions"
            :key="`endpage-action-1${index}`"
            :pseudolink="isPseudoLink(index)"
            :color="getColor(index)"
            :click="redirectEffrsSite"
            >EFFRS</Button
          >
        </template>
        <template slot="actions">
          <Button
            v-for="(action, index) in actions"
            :key="`endpage-action-2${index}`"
            :pseudolink="isPseudoLink(index)"
            :color="getColor(index)"
            :click="redirectLinInternationalSite"
            >LIN INTERNATIONAL</Button
          >
        </template>
        <template slot="actions">
          <Button
            v-for="(action, index) in actions"
            :key="`endpage-action-3 ${index}`"
            :pseudolink="isPseudoLink(index)"
            :color="getColor(index)"
            :click="redirectLotusSite"
            >LOTUS SERVICES</Button
          >
        </template>
      </EndPage>
      <div class="footerStyle">
        Note: This referral is free with no liability, obligation, accountability on the part of
        deem and its affiliates for any advise rendered by the debt counsellors. The applicant is
        advised to seek legal and tax assistance to ensure the advice received is suitable for their
        needs.
      </div>
    </div>
    <div v-if="isCreditScoreStatus">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
        <template slot="actions">
          <Button
            v-for="(action, index) in actions"
            :key="`endpage-action-1${index}`"
            :pseudolink="isPseudoLink(index)"
            :color="getColor(index)"
            :click="redirectEffrsSite"
            >EFFRS</Button
          >
        </template>
        <template slot="actions">
          <Button
            v-for="(action, index) in actions"
            :key="`endpage-action-2${index}`"
            :pseudolink="isPseudoLink(index)"
            :color="getColor(index)"
            :click="redirectLinInternationalSite"
            >LIN INTERNATIONAL</Button
          >
        </template>
        <template slot="actions">
          <Button
            v-for="(action, index) in actions"
            :key="`endpage-action-3 ${index}`"
            :pseudolink="isPseudoLink(index)"
            :color="getColor(index)"
            :click="redirectLotusSite"
            >LOTUS SERVICES</Button
          >
        </template>
      </EndPage>
      <div class="footerStyle">
        Note: This referral is free with no liability, obligation, accountability on the part of
        deem and its affiliates for any advise rendered by the debt counsellors. The applicant is
        advised to seek legal and tax assistance to ensure the advice received is suitable for their
        needs.
      </div>
    </div>
    <div v-if="isOfferRejected">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>
    <div v-if="isCreditScoreCalculation">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>

    <div v-if="isTechnicalError">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>

    <div v-if="isCreditScoreApproved">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>

    <div v-if="isCreditScoreRejected">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>

    <div v-if="isApplicationStatus">
      <EndPage :background="mainColor">
        <Feedback
          :title="`Thanks ${getName}.`"
          :subtitle="`Your application is already in progress.`"
          bigger-subtitle
        />
      </EndPage>
    </div>
    <div v-if="customerNotFound">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>
    <div v-if="isLeadCaptured">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>
    <div v-if="isDepositProduct">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>
    <div v-if="isMerchantLoan">
      <EndPage :background="mainColor">
        <Feedback :title="title" :subtitle="subtitle" bigger-subtitle />
      </EndPage>
    </div>
  </div>
</template>

<script>
import router from "@/router";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
import { Feedback, Button, EndPage, Choice } from "@dunia/ui";
import { MIN_TOTAL_INCOME_LOAN, INSURANCE } from "@/forms/constants/onboarding-logic";

import STEP_NAMES from "@/forms/constants/step-names";
import FIELD_NAMES from "@/forms/constants/field-names";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
import sleep from "@/forms/helpers/sleep";
export default {
  name: "OnboardDunia",

  components: {
    EndPage,
    Feedback,
    Button,
    Choice
  },
  data: () => ({
    productButtonText: ""
  }),
  props: {
    mainColor: {
      required: true,
      type: String
    },

    buttonColor: {
      required: true,
      type: String
    },

    title: {
      required: true,
      type: String
    },

    subtitle: {
      required: true,
      type: String
    },

    actions: {
      required: true,
      type: Array
    },
    index: {
      type: Number,
      default: 3
    }
  },
  async mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  computed: {
    isEmployeeCode() {
      if (this.$store.state.employeeCodes) {
        return true;
      } else {
        return false;
      }
    },
    isCreditScoreStatus() {
      var status = this.$store.state.creditScoreStatus;
      var flag = false;
      var appianPersonalInfo = this.$store.state.appianPersonalInfo;
      var productType = this.$store.state.productType;
      if (!appianPersonalInfo) {
        return status === "Not Eligible";
      }
    },
    isCreditScoreeAppian() {
      var appianResponse = this.$store.state.appianIdentityInfo;
      return appianResponse === "Failure";
    },
    isLeadCaptured() {
      var path = window.location.href;
      if (path.includes("lead-page/start")) {
        return true;
      }
    },
    isDepositProduct() {
      var path = window.location.href;
      if (path.includes("deposit-product")) {
        return true;
      }
    },
    isMerchantLoan() {
      var path = window.location.href;
      if (path.includes("merchant-loan")) {
        return true;
      }
    },
    isBasicEligibility() {
      var flag = false;
      var status = this.$store.state.creditScoreStatus;
      var fixedIncome = this.$store.state.basicEligibility5000;
      var variableIncome = this.$store.state.variableIncome;
      var emirates = this.$store.state.ineligibleEmirates;
      var productType = this.$store.state.productTypeFromUrl;
      var mediumOfReceive = this.$store.state.ineligibleMediumOfReceive;
      var appianPersonalInfo = this.$store.state.appianPersonalInfo;
      var employeeCode = this.$store.state.employeeCodes;
      var productType = this.$store.state.productType;
      var uaeVintage = this.$store.state.uaeVintage;
      var jobVintage = this.$store.state.jobVintage;
      var employmentType = this.$store.state.employmentType;
      var url = window.location.href;
      if (
        emirates === "Ajman" ||
        emirates === "Umm Al Quwain" ||
        emirates === "Ras Al Khaimah" ||
        (emirates === "Fujairah" && productType === "card")
      ) {
        flag = true;
      }
      if (
        emirates === "Umm Al Quwain" ||
        emirates === "Ras Al Khaimah" ||
        (emirates === "Fujairah" && productType === "loan")
      ) {
        flag = true;
      }
      if (mediumOfReceive === "Cash" || mediumOfReceive === "Cheque") {
        flag = true;
      }
      // if (employeeCode) {
      // if (!appianPersonalInfo) {
      //    console.log('!appianPersonalInfo');
      //   if (productType === "Credit Card") {
      //     console.log('inside credit card');
      //     if (parseInt(fixedIncome) >= 4000) {
      //       if (!variableIncome || flag) {
      //         return true;
      //       } else if (parseInt(variableIncome) || flag) {
      //         if (parseInt(fixedIncome) + parseInt(variableIncome) < 5000) {
      //           return true;
      //         }
      //       }
      //     } else if (parseInt(fixedIncome) < 4000 || flag) {
      //       return true;
      //     }
      //   } else if (productType === "Personal_Loan") {
      //     if (parseInt(fixedIncome) < MIN_TOTAL_INCOME_LOAN || uaeVintage !=='240+ Months' || flag) {
      //       return true;
      //     }
      //   }
      // }
      //   if(appianPersonalInfo) {
      //     if (appianPersonalInfo === "Failure") {
      //         console.log('employee code appianPersonalInfo===Failure');
      //       return true;
      //     }
      //   }
      // }
      // if (!jobVintage) {
      if (url.includes("/credit-card-aggregator/")) {
        if (parseInt(fixedIncome) < 5000 || flag) {
          return true;
        }
      }
      if (appianPersonalInfo) {
        if (appianPersonalInfo === "Failure") {
          return true;
        }
      }

      if (url.includes("/loan/")) {
        if (
          parseInt(fixedIncome) < MIN_TOTAL_INCOME_LOAN ||
          flag
          //uaeVintage !== "240+ Months" ||
          //flag
        ) {
          return true;
        }
      }
      // } else {
      //   console.log("not Job Vintage");
      //   if (employmentType === "Salaried") {
      //     console.log(employmentType);
      //     return jobVintage === "0-5 Months";
      //   } else if (employmentType === "Self-employed") {
      //     return jobVintage === "0-5 Months" || jobVintage === "6-11 Months";
      //   }
      // }
      return false;
    },
    isCreditScoreCalculation() {
      var decisionstatus = this.$store.state.creditScoreCalculationSatus;
      var employeeCode = this.$store.state.employeeCodes;
      var appianIncomeInfoResponse = this.$store.state.appianIncomeInfo;
      var appianEmpInfoResponse = this.$store.state.appianEmpInfo;
      if (employeeCode) {
        if (
          !appianIncomeInfoResponse &&
          !appianEmpInfoResponse &&
          decisionstatus === "Conditionally Approved" &&
          !this.$store.state.offerRejected
        ) {
          return true;
        }
        if (appianIncomeInfoResponse) {
          return (
            appianIncomeInfoResponse === "Conditionally Approved" &&
            !this.$store.state.offerRejected
          );
        }
      } else {
        if (
          !appianIncomeInfoResponse &&
          !appianEmpInfoResponse &&
          decisionstatus === "Conditionally Approved" &&
          !this.$store.state.offerRejected
        ) {
          return true;
        }
        if (appianIncomeInfoResponse) {
          return (
            appianIncomeInfoResponse === "Conditionally Approved" &&
            !this.$store.state.offerRejected
          );
        }
      }
      // return (
      //   decisionstatus === "Conditionally Approved" &&
      //   !this.$store.state.offerRejected
      // );
    },
    isCreditScoreRejected() {
      var decisionstatus = this.$store.state.creditScoreCalculationSatus;
      var appianIncomeInfoResponse = this.$store.state.appianIncomeInfo;
      var employeeCode = this.$store.state.employeeCodes;
      var appianEmpInfoResponse = this.$store.state.appianEmpInfo;
      if (employeeCode) {
        if (
          !appianEmpInfoResponse &&
          !appianIncomeInfoResponse &&
          decisionstatus === "Rejected" &&
          !this.$store.state.offerRejected
        ) {
          return true;
        }
        if (
          appianIncomeInfoResponse &&
          appianIncomeInfoResponse === "Rejected" &&
          !this.$store.state.offerRejected
        ) {
          return true;
        }
        if (appianEmpInfoResponse && appianEmpInfoResponse === "Rejected") {
          return true;
        }
      } else {
        if (
          !appianEmpInfoResponse &&
          !appianIncomeInfoResponse &&
          decisionstatus === "Rejected" &&
          !this.$store.state.offerRejected
        ) {
          return true;
        }
        if (
          appianIncomeInfoResponse &&
          appianIncomeInfoResponse === "Rejected" &&
          !this.$store.state.offerRejected
        ) {
          return true;
        }
        if (appianEmpInfoResponse && appianEmpInfoResponse === "Rejected") {
          return true;
        }
      }
    },
    isTechnicalError() {
      var employeeCode = this.$store.state.employeeCodes;
      var decisionstatus = this.$store.state.creditScoreCalculationSatus;
      var appianPersonalInfoResponse = this.$store.state.appianPersonalInfo;
      var appianIdententyInfoResponse = this.$store.state.appianIdentityInfo;
      var appianEmpInfoResponse = this.$store.state.appianEmpInfo;
      var appianIncomeInfoResponse = this.$store.state.appianIncomeInfo;
      var cifError = this.$store.state.isCifError;
      var cifErrorCount = this.$store.state.cifErrorCount;
      if (employeeCode) {
        if (
          !appianPersonalInfoResponse &&
          !appianIdententyInfoResponse &&
          !appianEmpInfoResponse &&
          !appianIncomeInfoResponse &&
          decisionstatus === "Technical Error"
        ) {
          return true;
        }

        if (appianPersonalInfoResponse && appianPersonalInfoResponse === "Technical Error") {
          return true;
        }
        if (appianIdententyInfoResponse && appianIdententyInfoResponse === "Technical Error") {
          return true;
        }
        if (appianEmpInfoResponse && appianEmpInfoResponse === "Technical Error") {
          return true;
        }
        if (appianIncomeInfoResponse && appianIncomeInfoResponse === "Technical Error") {
          return true;
        }
      } else {
        if (
          !appianPersonalInfoResponse &&
          !appianIdententyInfoResponse &&
          !appianEmpInfoResponse &&
          !appianIncomeInfoResponse &&
          decisionstatus === "Technical Error"
        ) {
          return true;
        }
        if (appianPersonalInfoResponse && appianPersonalInfoResponse === "Technical Error") {
          return true;
        }
        if (appianIdententyInfoResponse && appianIdententyInfoResponse === "Technical Error") {
          return true;
        }
        if (appianEmpInfoResponse && appianEmpInfoResponse === "Technical Error") {
          return true;
        }
        if (appianIncomeInfoResponse && appianIncomeInfoResponse === "Technical Error") {
          return true;
        }
        if (cifError && this.$store.state.cifErrorCount > 1) {
          return true;
        }
      }

      // if (appianEmpInfoResponse) {
      //   return appianEmpInfoResponse === "Technical Error";
      // }
    },
    // isAppianTechnicalError() {
    //   return this.$store.state.appianIdentityInfo === "Technical Error";
    // },
    // isAppianEmpTechnicalError() {
    //   return this.$store.state.appianEmpInfo === "Technical Error";
    // },
    isCreditScoreApproved() {
      var decisionstatus = this.$store.state.creditScoreCalculationSatus;
      var employeeCode = this.$store.state.employeeCodes;
      var appianIncomeInfoResponse = this.$store.state.appianIncomeInfo;
      var appianEmpInfoResponse = this.$store.state.appianEmpInfo;
      if (employeeCode) {
        if (!appianIncomeInfoResponse && !appianEmpInfoResponse && decisionstatus === "Approved") {
          return true;
        }
        if (appianIncomeInfoResponse) {
          return appianIncomeInfoResponse === "Approved";
        }
      } else {
        if (!appianIncomeInfoResponse && !appianEmpInfoResponse && decisionstatus === "Approved") {
          return true;
        }
        if (appianIncomeInfoResponse) {
          return appianIncomeInfoResponse === "Approved";
        }
      }
    },
    isProducttype() {
      var product = this.$store.state.productType;
      if (product === "Personal_Loan") {
        return "Personal Loan";
      } else if (product === "Credit Card") {
        return "Credit Card";
      }
    },
    isErrorInServiceCall() {
      var errorMessage = this.$store.state.serviceError;

      if (errorMessage) {
        return true;
      } else {
        false;
      }
    },
    isOfferRejected() {
      var decisionstatus = this.$store.state.creditScoreCalculationSatus;
      var employeeCode = this.$store.state.employeeCodes;
      var appianIncomeInfoResponse = this.$store.state.appianIncomeInfo;
      var feedback = this.$store.state.offerRejected;
      if (employeeCode) {
        if (!appianIncomeInfoResponse && decisionstatus) {
          if (feedback) {
            return feedback === "OfferRejected";
          }
        }
        if (appianIncomeInfoResponse) {
          if (feedback) {
            return feedback === "OfferRejected";
          }
        }
      } else {
        if (decisionstatus) {
          if (feedback) {
            return feedback === "OfferRejected";
          }
        }
      }
    },

    isApplicationStatus() {
      var applicationStatus = this.$store.state.applicationStatus;
      if (applicationStatus) {
        return parseInt(applicationStatus) > 0;
      }
    },
    customerNotFound() {
      var referalCif = this.$store.state.referalCif;
      var existingCustomer = this.$store.state.customerExist;
      if (existingCustomer) {
        return existingCustomer === "N";
      }
    },
    getName() {
      return this.$store.state.firstName;
    }
  },
  methods: {
    isPseudoLink(index) {
      return index > 0 && router.isOnEndPage;
    },

    getColor(index) {
      if (this.isPseudoLink(index)) {
        return null;
      }
      return this.buttonColor;
    },

    getHTML(index, label) {
      if (this.isPseudoLink(index)) {
        return `<span>${label}</span>`;
      }
      return label;
    },
    isPseudoLink2(index) {
      return index > 0 && router.isOnEndPage;
    },

    getColor2(index) {
      if (this.isPseudoLink(index)) {
        return null;
      }
      return this.buttonColor;
    },

    getHTML2(index, label) {
      if (this.isPseudoLink(index)) {
        return `<span>${label}</span>`;
      }
      return label;
    },
    redirectEffrsSite: function() {
      window.location.href = "http://effrs.com/";
    },
    redirectLinInternationalSite: function() {
      window.location.href = "http://www.lininternational.net/debt-services/";
    },
    redirectLotusSite: function() {
      window.location.href = "https://www.lotusadvisoryuae.com/";
    },

    redirectToDeem: function() {
      window.location.href =
        "https://www.deem.io?utm_source=RejectTY&utm_medium=Button&utm_campaign=LoanApp";
    }
  }
};
</script>
<style scoped>
.footerStyle {
  background-color: #6e3dea;
  display: block;
  color: #fff;
  box-sizing: inherit;
  text-align: justify;
  font-family: "Moderat", serif;
  font-weight: 300;
  font-size: 13px;
  line-height: 24px;
  letter-spacing: 0px;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  padding-left: 19%;
  padding-right: 19%;
  padding-bottom: 5%;
  text-transform: uppercase;
}
@keyframes blink {
  /**
     * At the start of the animation the dot
     * has an opacity of .2
     */
  0% {
    opacity: 0.2;
  }
  /**
     * At 20% the dot is fully visible and
     * then fades out slowly
     */
  20% {
    opacity: 1;
  }
  /**
     * Until it reaches an opacity of .2 and
     * the animation can start again
     */
  100% {
    opacity: 0.2;
  }
}

.redirectMessage {
  color: #fff;
  font-size: 36px;
  line-height: 44px;
  letter-spacing: -1px;
  font-family: "Moderat", serif;
  font-weight: 500;
  font-feature-settings: "ss02";
  -webkit-font-smoothing: antialiased;
}
.redirectMessage .animation {
  animation-name: blink;
  /**
     * The animation should take 1.4 seconds
     */
  animation-duration: 0.5s;
  /**
     * It will repeat itself forever
     */
  animation-iteration-count: infinite;
}

@media (max-width: 768px) {
  [class="footerStyle"] {
    background-color: #6e3dea;
    background-color: aqua;
    /* display: block; */
    color: #fff;
    /* box-sizing: inherit; */
    text-align: justify;
    font-family: "Moderat", serif;
    font-weight: 300;
    font-size: 13px;
    /* line-height: 24px; */
    letter-spacing: 0px;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    padding-left: 7%;
    padding-right: 7%;
    padding-bottom: 7%;
    text-transform: uppercase;
  }
}
</style>
